/**
 * 其知网 缴费管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>缴费管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.zlmc" style="width:120px" placeholder="输入专利名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:120px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.zlid" style="width:120px" placeholder="输入专利号"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.is_enable" style="width:100px" placeholder="请选择">
          <el-option v-for="type in is_enable" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item>
        <el-select size="small" v-model="formInline.zfsj" style="width:100px" placeholder="请选择">
          <el-option v-for="type in zfsj" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:150px" placeholder="选择开始时间"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:150px" placeholder="选择结束时间"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="zlmc" align="center" label="专利名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="zlid" align="center" label="专利号" width="130" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="联系方式" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pay_able" align="center" label="缴费明细" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="total_fee" align="center" label="缴费总额" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="service_fee" align="center" label="服务费" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pay_time" align="center" label="支付时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="invoice_info" align="center" label="票据信息" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="email" align="center" label="邮箱" width="140" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="status" :formatter="statusFormat" label="支付状态" width="70" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="pay_type_name" align="center" label="支付方式" width="70" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="is_enable" :formatter="sfqyFormat" align="center" label="是否处理" width="70" show-overflow-tooltip>
      </el-table-column> -->

      <el-table-column align="center" prop="status" label="支付状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ASSET_STATUS[scope.row.status].type">
                {{ASSET_STATUS[scope.row.status].status}}
              </el-tag>
            </div>
          </template> 
      </el-table-column>
      <el-table-column align="center" prop="is_enable" label="是否处理" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ASSET_SFQY[scope.row.is_enable].type">
                {{ASSET_SFQY[scope.row.is_enable].sfqy}}
              </el-tag>
            </div>
          </template>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" type="danger" @click="handleFee(scope.$index, scope.row)">处理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlid" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="缴费明细">
              <el-input size="small" v-model="infoForm.pay_able" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="缴费总额">
              <el-input size="small" v-model="infoForm.total_fee" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付时间">
              <el-input size="small" v-model="infoForm.pay_time" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="票据信息">
              <el-input size="small" v-model="infoForm.invoice_info" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址">
              <el-input size="small" v-model="infoForm.email" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付状态">
              <el-input size="small" v-model="infoForm.status" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否处理">
              <el-input size="small" v-model="infoForm.is_enable" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { webOrderList, webUrl, webHandleFee, webExportCheckOrder, webExportAllOrder } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '缴费详情',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      status: [
        { key: '全部', value: 0 },
        { key: '未支付', value: 1 },
        { key: '已支付', value: 2 },
        { key: '退款中', value: 3 },
        { key: '已退款', value: 4 },
      ],
      is_enable: [
        { key: '全部', value: 0 },
        { key: '未处理', value: 1 },
        { key: '已处理', value: 2 }
      ],
      zfsj: [
        { key: '全部', value: 0 },
        { key: '近一月', value: 1 },
        { key: '近半年', value: 2 },
        { key: '近一年', value: 3 }
      ],
       ASSET_STATUS: {
      '1': { 'status': '未支付', 'type': 'info' },
      '2': { 'status': '已支付', 'type': 'primary' },
      '3': { 'status': '退款中', 'type': 'warning' },
      '4': { 'status': '已退款', 'type': 'danger' }
      },
      ASSET_SFQY: {
      '1': { 'sfqy': '未处理', 'type': 'primary' },
      '2': { 'sfqy': '已处理', 'type': 'info' }
      },
      infoForm: {
        add_time: '',
        address: '',
        address_mobile: '',
        address_name: '',
        invoice_get_name: '',
        invoice_name: '',
        mobile: '',
        pay_time: '',
        sqr: '',
        sqrq: '',
        status: '',
        total_fee: '',
        wx_name: '',
        zlbh: '',
        zllx: '',
        zlmc: '',
        invoice_info: '',
        fee_string: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        zlmc: '',
        mobile: '',
        zlid: '',

        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
       this.loading = true
    //   this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if(parameter.start_time == null){
          parameter.start_time = '';
      }
      if(parameter.end_time == null){
          parameter.end_time = '';
      }
      webOrderList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
      }
       this.$confirm('确定导出勾选的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr)
          console.log(idStr)
          // 请求接口
          const checkParam = {ids:idStr}
            webExportCheckOrder(checkParam)
            .then(res => {
              this.loading = false
              console.log(res);
              res = checkLogin(res);
              if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: '导出成功!'
                  })
              location.href = res.data.url
              } else {
                this.$message({
                    type: 'info',
                    message: res.msg
                  })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('登陆已过期,请重新登陆!')
            })
          
       })
       .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
       this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          const parameter = this.formInline

          if(parameter.start_time == null){
              parameter.start_time = '';
          }
          if(parameter.end_time == null){
              parameter.end_time = '';
          }
        webExportAllOrder(parameter)
              .then(res => {
                this.loading = false
                console.log(res);
                res = checkLogin(res);
                if (res.code == 200) {
                  this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                location.href = res.data.url
                } else {
                  this.$message({
                      type: 'info',
                      message: res.msg
                    })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })

          })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 处理专利年费缴纳
    handleFee(index, row) {
      if(row.is_enable == 2){
        this.$message({
          type: 'info',
          message: '该专利缴费已处理'
        })
        return false;
      }
      if(row.status != 2){
        this.$message({
          type: 'info',
          message: '该专利缴费不是已支付状态'
        })
        return false;
      }
      this.$confirm('确定已经处理了吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const handleParam = {'id':row.id,'zlid':row.zlid,'mobile':row.mobile}
          console.log(handleParam)
          this.loading = true
          webHandleFee(handleParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: '处理成功'
                })
                this.getdata(this.formInline)
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消处理'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    //根据不同值显示不同文本内容
    statusFormat(row,column){
      if(row.status == 1){
          return '未支付'
      }else if(row.status == 2){
          return '已支付'
      }else if(row.status == 3){
          return '退款中'
      }else if(row.status == 4){
          return '已退款'
      }else{
          return '未知'
      }
    },
    invoiceTypeFormat(row,column){
        if(row.invoice_type == 1){
          return '纸质发票'
        }
        else if(row.invoice_type == 2){
          return '电子发票'
        }else{
          return '无'
        }
    },
    sfqyFormat(row,column){
        if(row.is_enable == 1){
          return '未处理'
        }else{
          return '已处理'
        }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Feepay.vue